module.exports = require("@common-stack/core");